export default "__VITE_ASSET__Dm29jtC7__"